import { withInstall } from '@jdesign-vue/utils'
import Countdown from './src/countdown.vue'

export const JdCountdown = withInstall(Countdown)
export default JdCountdown

export * from './src/countdown'
